<template>
  <div class="lm-wrap">
    <div class="title">{{ yc.subtit || yc.title }}</div>
    <!-- 视频播放 -->
    <div class="desc" v-if="lmid == 'video'">
      <video-player :video="yc['json']" />
      <ad-link class="pd-t"></ad-link>
    </div>
    <!-- 特定类型数据 -->
    <template v-else-if="yc.type">
      <!-- 1.推荐产品 -->
      <van-tabs
        v-if="yc.type == 'goods'"
        class="lm-tab"
        v-model="tabi"
        :ref="lmid"
        swipeable
        animated
      >
        <van-tab v-for="(lm, lmk) in yc['goods']" :title="lmk" :key="lmk">
          <van-row type="flex" gutter="5" style="margin: 5px">
            <van-col span="8" v-for="(goods, gkey) in lm" :key="gkey">
              <a
                :href="base.shopurl + '/show-' + goods.id + '.html'"
                target="_blank"
              >
                <van-image :src="imgUrl + '/sxyc/goods/' + goods.id + '.jpg'" />
              </a>
              <div>{{ goods.title }}</div>
              <div class="goods-intro">{{ goods.intro }}</div>
            </van-col>
          </van-row>
        </van-tab>
      </van-tabs>
      <!-- 新闻文章 -->
      <div class="news-box" v-if="yc.type == 'news'">
        <van-row
          type="flex"
          gutter="5"
          v-for="(rows, ri) in yc[yc.type]"
          :key="ri"
        >
          <van-col v-for="(news, ni) in rows" :key="ni">
            <a
              :href="base.shopurl + '/xinwen/view-' + news.id + '.html'"
              target="_blank"
            >
              <van-image :src="news.thumb" class="thumb" radius="3px" />
            </a>
          </van-col>
        </van-row>
      </div>
    </template>
    <!-- 文本栏目 -->
    <div class="desc" v-else-if="yc.desc" v-html="formatHTML(yc.desc)"></div>
    <!-- 二级选项卡栏目 -->
    <van-tabs
      v-else
      class="lm-tab"
      v-model="tabi"
      :ref="lmid"
      swipeable
      animated
    >
      <van-tab
        v-for="(item, key) in yc.item"
        :title="item.title"
        :name="item.title"
        :key="key"
      >
        <div class="sub-title pds-a txt-bold skin-txt" v-if="item.subtit">
          {{ item.subtit }}
        </div>
        <!-- 生肖产品模块 -->
        <van-row v-if="lmid == 'goods'" type="flex" gutter="5" class="mg-a">
          <van-col span="7">
            <a
              :href="base.shopurl + '/show-' + base.goods[key].id + '.html'"
              target="_blank"
            >
              <van-image
                :src="imgUrl + base.goods[key].thumb"
                width="100%"
              ></van-image>
            </a>
          </van-col>
          <van-col span="16" class="txt-l">
            <a
              :href="base.shopurl + '/show-' + base.goods[key].id + '.html'"
              target="_blank"
              class="txt-h2 txt-bold txt-d-blue"
              >{{ base.goods[key].title }}</a
            >
            <div class="txt-h5 txt-gray pds-y">{{ base.goods[key].intro }}</div>
            <div class="flex-x fe-m">
              <div class="fe-full txt-d-red">
                ￥
                <strong>{{ base.goods[key].price }}</strong>
              </div>
              <van-button
                size="small"
                icon="shopping-cart"
                :url="base.shopurl + '/show-' + base.goods[key].id + '.html'"
                type="primary"
                >查看详情</van-button
              >
            </div>
          </van-col>
        </van-row>
        <div class="desc" v-html="formatHTML(item.desc)"></div>
      </van-tab>
    </van-tabs>
    <div class="lm-footer flex-x fe-m skin-bg txt-white mgs-a round-sm">
      <div class="fe-full flex-x fe-c fe-m suan-btn" @click="showDs">
        <van-icon name="manager" class="mgs-r" />
        <span>咨询师傅</span>
      </div>
      <div @click="showAsk" class="fe-full flex-x fe-c fe-m askq-btn txt-white">
        <van-icon name="question" class="mgs-r" />
        <span>留言提问</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import VideoPlayer from '../components/video-player'
import adLink from '../components/ad-link'
export default {
  components: {
    adLink,
    VideoPlayer
  },
  data() {
    return {
      tabi: 0
    }
  },
  props: {
    //prms: Object,
    lmid: String
  },
  computed: {
    ...mapState([
      'sxdata',
      'sxyc',
      'base',
      'imgUrl',
      'sellid',
      'from',
      'askShow'
    ]),
    yc() {
      return this.sxyc[this.lmid]
    }
  },
  methods: {
    showDs() {
      this.$store.commit('setDsShow', true)
    },
    showAsk() {
      this.$store.commit('setAskShow', true)
    },
    lmtitle(title) {
      let lmtit = this.sxyc.title
      if (lmtit == '七星指标') {
        title = title.substr(0, 1)
      } else if (lmtit == '每月运势') {
        title = title.substr(2, 2)
      }
      return title
    },
    formatHTML(html) {
      let sellid = this.sellid
      let from = this.from
      //连接添加Sellid
      let mch = html.match(/href="(.+?)"/g)
      if (mch) {
        mch.forEach((item) => {
          let mg = item.match(/href="(.+?)"/)
          if (sellid || from) {
            let url = mg[1]
            if (sellid) {
              url += (url.indexOf('?') >= 0 ? '&' : '?') + 'sellid=' + sellid
            }
            if (from) {
              url += (url.indexOf('?') >= 0 ? '&' : '?') + 'from=' + from
            }

            let nmg = item.replace(new RegExp(mg[1], 'g'), url)
            html = html.replace(new RegExp(mg[0], 'g'), nmg)
          }
        })
      }
      return html
    }
  }
}
</script>

<style lang="scss" scoped>
.lm-wrap {
  border-radius: 5px;
  background-color: #fff;
  margin: 7px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);

  .title {
    font-weight: bold;
    padding-top: 0.2em;
    line-height: 2em;
    font-size: 1.2em;
  }
  .desc {
    padding: 7px;
    text-align: justify;
  }
  .desc /deep/ p {
    line-height: 1.5em;
    margin-top: 0px;
    margin-bottom: 8px;
    text-indent: 2em;
  }
  .lm-footer {
    overflow: hidden;
    border-radius: 5px;
    line-height: 2em;
    div:active {
      box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.5);
    }
    .suan-btn {
      border-right: solid 1px rgba(0, 0, 0, 0.2);
    }
  }
}

.lm-tab {
  /deep/ .van-tab {
    border: #eee solid;
    border-width: 1px 0;
  }
}
.goods-card {
  text-align: left;
}

.news-box {
  padding: 5px;
  .thumb {
    width: 100%;
    border-radius: 5px;
  }
  .thumb:after {
    content: '点击查看新闻';
    position: absolute;
    right: 5px;
    bottom: 5px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 12px;
    padding: 0 5px;
    line-height: 20px;
    border-radius: 3px;
  }
}

/*  */
.goods-intro {
  color: #999;
  font-size: 13px;
}

/* SKIN */
.skin-male {
  .skin-txt {
    color: #966a26;
  }
  .lm-wrap .title {
    color: #966a26;
    background-image: linear-gradient(1turn, #fff, #fdd699);
    background-image: -webkit-linear-gradient(1turn, #fff, #fdd699);
  }
}
.skin-female {
  .skin-txt {
    color: #e75741;
  }
  .lm-wrap .title {
    color: #e75741;
    background-image: linear-gradient(1turn, #fff, #fdcfb8);
    background-image: -webkit-linear-gradient(1turn, #fff, #fdcfb8);
  }
}
</style>